import { SEARCH, HTTP } from '@/utils/http';
import * as actionTypes from '../types/actions';
import * as getterTypes from '../types/getters';
import * as mutationTypes from '../types/mutations';

const getters = {
  [getterTypes.GET_EVENT]: state => state.event,
  [getterTypes.GET_EVENTS]: state => state.events,
};

const actions = {
  async [actionTypes.DO_GET_EVENTS]({ commit }, params) {
    const response = await SEARCH.post('/doxa_events/_search', params);
    const { hits } = response.data;
    if (hits.total > 0) {
      commit(mutationTypes.SET_EVENTS, hits.hits.map(h => h._source));
      return response.data;
    }
    return response.data;
  },
  async [actionTypes.DO_GET_EVENT]({ commit }, payload) {
    const { id, ...params } = payload;
    const { data } = await HTTP.get(`/events/${id}`, { params });
    commit(mutationTypes.SET_EVENT, data.data.events[0]);
    return data;
  },
};

const mutations = {
  [mutationTypes.SET_EVENT](state, e) {
    state.event = e;
  },
  [mutationTypes.SET_EVENTS](state, events) {
    state.events = events;
  },
};

export default {
  getters,
  actions,
  mutations,
  state: {
    event: {},
    events: [],
  },
};
